module.exports = __webpack_public_path__ + "src/assets/it.95a3d6c2.png";